import BlockGridGallery from './BlockGridGallery'
import BlockGridDrag from './BlockGridDrag'

const blockList = [
  {
    name: 'js-grid-gallery',
    Class: BlockGridGallery
  },
  {
    name: 'js-grid-gallery-drag',
    Class: BlockGridDrag
  }
]

export default blockList
